module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"#common #contest #contest":{"hooks.onStartRendering":[{"value":function () {
this.setOption('template', 'promo_contest_en')
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101008},"path":"#common #contest #contest","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ../common/options/contest.js
// module id = 406
// module chunks = 2